module.exports = __webpack_public_path__ + "img/wep_spear05.2eb21681.png";